import * as _login_services from './loginServices'
//import { browserHistory } from 'react-router'

export const loginServices = _login_services
//export const history = browserHistory
